<template>
    <div class="flex">
        <div class="relative">
            <DatePicker
                ref="datePicker"
                v-model="date"
                :locale="locale"
                v-bind="$attrs"
                :model-modifiers="modelModifiers"
                class="calendar"
                :trim-weeks="trimWeeks"
                :mode="mode"
                :is-required="isRequired"
                :transition="'none'"
                :disabled-dates="disabledDates"
                :min-date="minDate"
                :max-date="maxDate"
                :is-24hr="is24hr"
                hide-time-header
                :columns="columns" />
        </div>
    </div>
</template>

<script setup>
import {DatePicker} from 'v-calendar'
import {useI18n} from "vue-i18n"

const {locale} = useI18n()

defineOptions({
    inheritAttrs: false,
})

const props = defineProps({
    modelValue: {
        type: [String, Number, Date, Object, null],
        default: () => ({start: null, end: null})
    },
    modelModifiers: {
        type: Object,
        default: () => ({})
    },
    columns: {
        type: Number,
        default: 1
    },
    trimWeeks: {
        type: Boolean,
        default: true
    },
    mode: {
        type: String,
        default: 'date',
        validation: (value) => ['date', 'dateTime', 'time'].includes(value)
    },
    isRequired: {
        type: Boolean,
        default: false
    },
    disabledDates: {
        type: Array,
        default: () => []
    },
    minDate: {
        type: [String, Number, Date, Object, null],
        default: null
    },
    maxDate: {
        type: [String, Number, Date, Object, null],
        default: null
    },
    is24hr: {
        type: Boolean,
        default: true
    }
})

const emits = defineEmits(['update:modelValue'])
const date = computed({
    get: () => props.modelValue,
    set: (value) => emits('update:modelValue', value)
})

const datePicker = ref(null)
const calendarRef = computed(() => {
    if (datePicker.value) {
        return datePicker.value.calendarRef
    }
    return null
})

onMounted(async () => {
    await nextTick()
    if (props.modelValue instanceof Date && calendarRef.value) {
        calendarRef.value.focusDate(props.modelValue)
    }
})
</script>